/** User-facing copy for project feature (forms, media uploads) */
export const projectStrings = {
  formSectionMainInfo: "Main information",
  formSectionLocation: "Ubicación",
  formSectionSellInfo: "Sell information",
  formFieldTitle: "Title",
  formFieldSlug: "Slug",
  formFieldSlugHelper:
    "Unique URL segment: lowercase letters, digits, single hyphens (kebab-case). Max 120 characters. Leave empty if unused.",
  formFieldSlugErrorInvalid:
    "Use kebab-case only (e.g. lote-norte). No leading, trailing, or double hyphens.",
  formFieldDescription: "Description",
  formSectionAmenitiesGroups: "Amenity groups (marketing)",
  formAmenitiesGroupsHint:
    "Structured groups for the public site: pick an icon, a section title, and amenity labels. Updating a project replaces this whole list when you save.",
  formAmenitiesGroupsAddGroup: "Add group",
  formAmenitiesGroupsRemoveGroup: "Remove group",
  formAmenitiesGroupsGroupTitle: "Group title",
  formAmenitiesGroupsLabels: "Amenity labels",
  formAmenitiesGroupsLabelsPlaceholder: "Type and press Enter",
  formAmenitiesGroupsPickIcon: "Icon",
  formAmenitiesGroupsIconDialogTitle: "Choose icon",
  formAmenitiesGroupsEmpty: "No groups yet.",
  amenityGroupIcon_category: "General",
  amenityGroupIcon_pool: "Pool / water",
  amenityGroupIcon_bolt: "Utilities / power",
  amenityGroupIcon_water_drop: "Water supply",
  amenityGroupIcon_plumbing: "Sewer / drainage",
  amenityGroupIcon_security: "Security / gate",
  amenityGroupIcon_beach_access: "Beach / events venue",
  amenityGroupIcon_spa: "Spa / wellness",
  amenityGroupIcon_deck: "Terrace / lounge",
  amenityGroupIcon_hot_tub: "Jacuzzi",
  amenityGroupIcon_sports_tennis: "Tennis",
  amenityGroupIcon_sports_golf: "Golf",
  amenityGroupIcon_sports_soccer: "Soccer",
  amenityGroupIcon_sports_volleyball: "Volleyball",
  amenityGroupIcon_sports: "Sports / padel",
  amenityGroupIcon_hiking: "Trails / hiking",
  amenityGroupIcon_groups: "Common areas",
  amenityGroupIcon_waves: "Pools / aquatic",
  amenityGroupIcon_child_care: "Kids / playground",
  amenityGroupIcon_pets: "Pet area",
  amenityGroupIcon_outdoor_grill: "BBQ",
  amenityGroupIcon_villa: "Club house",
  amenityGroupIcon_door_front: "Lobby / gatehouse",
  amenityGroupIcon_admin_panel: "Administration",
  amenityGroupIcon_recycling: "Waste area",
  amenityGroupIcon_sports_basketball: "Multi-sport court",
  amenityGroupIcon_fitness_center: "Gym / calisthenics",
  amenityGroupIcon_self_improvement: "Yoga",
  amenityGroupIcon_directions_bike: "Cycling",
  amenityGroupIcon_terrain: "Adventure / off-road",
  amenityGroupIcon_flag: "Paintball / activity",
  amenityGroupIcon_park: "Nature / conservation",
  amenityGroupIcon_air: "Birdwatching",
  amenityGroupIcon_cabin: "Camping",
  amenityGroupIcon_kayaking: "Lake / water",
  amenityGroupIcon_restaurant: "Picnic",
  amenityGroupIcon_local_fire_department: "Fire pit",
  formFieldLocation: "Location",
  formFieldLocationPlaceholder: "Address or Google Maps link",
  formFieldCity: "City",
  formFieldState: "State",
  formFieldCountry: "Country",
  formFieldLatitude: "Latitude",
  formFieldLongitude: "Longitude",
  formOpenInMaps: "Open in Google Maps",
  formFieldSellPriceCop: "Sell price (COP)",
  formFieldSellPriceUsd: "Sell price (USD)",
  formFieldCommissionPercent: "Commission %",
  formFieldCommissionCop: "Commission (COP)",
  formFieldSeparation: "Separation",
  formFieldSeparationHelper:
    "Distance between lots (use the same unit your team uses, e.g. meters).",
  formLotOptionsTitle: "Lot sizes and prices",
  formLotOptionsAdd: "Add lot option",
  formLotOptionsArea: "Area (m²)",
  formLotOptionsPriceCop: "Price (COP)",
  formLotOptionsPriceUsd: "Price (USD)",
  formLotOptionsRemove: "Remove row",
  formLotOptionsEmptyHint: "Add one row per lot size with its sale price.",

  mediaPreviewTitle: "Preview",
  mediaPreviewClose: "Close",
  mediaPreviewNext: "Next",
  mediaPreviewBack: "Back",
  projectImagesTitle: "Project images",
  projectImagesSectionTitle: "Project images",
  tabProjectCard: "Project card",
  tabVerticalImages: "Vertical images",
  tabHorizontalImages: "Horizontal images",
  projectCardImageTitle: "Project card image",
  projectCardImageHelper: "JPEG, PNG or WebP — max 10 MB. Replaces the previous card image.",
  removeCardImage: "Remove card image",
  removeCardImageConfirmTitle: "Remove card image",
  removeCardImageConfirmBody:
    "Remove the listing card image? The file will be deleted from storage. This cannot be undone.",
  projectVideosSectionTitle: "Project videos",
  reelVideosTab: "Reel videos",
  horizontalVideosTab: "Horizontal videos",
  projectVerticalVideosTitle: "Videos",
  noVideosYet: "No videos yet",
  uploadVideos: "Upload videos",
  pickVideos: "Pick videos",
  verticalVideosUploadHelper:
    "Portrait promotional videos — max 16 MB each — saved immediately when editing",
  verticalVideosAddedOnSave: "Max 16 MB each — added when you save the project",
  removeVideoConfirmTitle: "Remove video",
  removeVideoConfirmBody:
    "Remove this video from the project? This cannot be undone.",
  uploadImages: "Upload images",
  pickImages: "Pick images",
  uploading: "Uploading…",
  imageSavedImmediate: "Max 10 MB each — images are saved immediately",
  imageAddedOnSave: "Max 10 MB each — added when you save the project",
  imageFileTooLarge: "Each image must be 10 MB or smaller.",
  previewImage: "Preview",
  removeImage: "Remove image",
  removeVideo: "Remove video",
  removePendingMedia: "Remove",
  removeImageConfirmTitle: "Remove image",
  removeImageConfirmBody:
    "Remove this image from the project? This cannot be undone.",
  cancel: "Cancel",
  delete: "Delete",
  deleting: "Deleting…",
  reelVideoLabel: "Reel video",
  reelVideoHelper: "MP4, WebM, QuickTime or AVI — max 16 MB",
  videoFileTooLarge: "Each video must be 16 MB or smaller.",
  removeReelVideo: "Remove reel video",
  removeReelVideoConfirmTitle: "Remove reel video",
  removeReelVideoConfirmBody:
    "Remove the reel video from this project? The file will be deleted from storage. This cannot be undone.",
  planeLabel: "Floor plan",
  planeHelper: "PDF or image — max 20 MB",
  removePlane: "Remove floor plan",
  removePlaneConfirmTitle: "Remove floor plan",
  removePlaneConfirmBody:
    "Remove the floor plan file from this project? The file will be deleted from storage. This cannot be undone.",
  brochureLabel: "Brochure",
  brochureHelper: "PDF only — max 20 MB",
  removeBrochure: "Remove brochure",
  removeBrochureConfirmTitle: "Remove brochure",
  removeBrochureConfirmBody:
    "Remove the brochure from this project? The file will be deleted from storage. This cannot be undone.",
  replaceFile: "Replace file",
  chooseFile: "Choose file",
  openPreview: "Preview",
  noImagesYet: "No images yet",
  carouselPrev: "Previous image",
  carouselNext: "Next image",

  documentIngestionButton: "Ingestions de Documentos",
  documentIngestionDialogTitle: "Ingesta de documentos del proyecto",
  documentIngestionDialogDescription:
    "Cada documento usa un tipo fijo del sistema. Para PDF o Word por archivo, la descripción es opcional (el texto incrustado se extrae del archivo). Para imágenes, reel/video, plano o brochure se exige una descripción larga. Elija archivo o URL. Los documentos adicionales requieren una clave identificadora.",
  documentIngestionStandardSection: "Documentos estándar",
  documentIngestionAdditionalSection: "Documentos adicionales",
  documentIngestionAddOther: "Agregar otro documento",
  documentIngestionSubmitting: "Enviando…",
  documentIngestionSendCount: "Enviar {{count}} documento(s)",
  documentIngestionClose: "Cerrar",
  documentIngestionSourceModeLabel: "Documento: archivo o URL",
  documentIngestionModeUpload: "Subir archivo",
  documentIngestionModeUrl: "URL externa",
  documentIngestionDescriptionLabel: "Descripción en texto",
  documentIngestionDescriptionPlaceholder: "Describa el documento (obligatorio salvo PDF/Word subidos como archivo).",
  documentIngestionDescriptionHelper:
    "Obligatorio para este tipo. Se envía como rawText junto al archivo o la URL.",
  documentIngestionDescriptionPlaceholderOptionalPdfWord:
    "Opcional para PDF/Word: el texto para búsqueda se toma del archivo.",
  documentIngestionDescriptionHelperOptionalPdfWord:
    "Opcional si el archivo es PDF o Word. Tras ingerir, aquí verá el texto extraído al recargar la lista.",
  documentIngestionDescriptionPlaceholderLong:
    "Descripción detallada del contenido (mín. {{min}} caracteres)…",
  documentIngestionDescriptionHelperLong:
    "Obligatorio para imágenes, reel/video, plano o brochure: mínimo {{min}} caracteres.",
  documentIngestionOtherDocumentKey: "Clave o nombre del documento",
  documentIngestionOtherDocumentKeyPlaceholder: "Ej. contrato_apto_101",
  documentIngestionOtherDocumentKeyHelper:
    "Obligatorio para documentos adicionales: identificador que recibirá el asistente como nombre del documento.",
  documentIngestionExternalUrl: "URL del documento (debe devolver texto)",
  documentIngestionExternalUrlPlaceholder: "https://…",
  documentIngestionExternalUrlHelper: "El contenido incrustado se obtiene de esta URL; la descripción se envía además como rawText.",
  documentIngestionPickFile: "Elegir archivo",
  documentIngestionComplete: "Listo para enviar",
  documentIngestionEditedBadge: "Editado — requiere re-ingesta",
  documentIngestionAdditionalBadge: "Adicional",
  documentIngestionSuccess: "{{count}} documento(s) ingerido(s).",
  documentIngestionPartialFailure: "{{count}} documento(s) fallaron.",
  documentIngestionNothingToSend: "No hay documentos listos para enviar.",
  documentIngestionNetworkError: "Error de red al ingerir.",
  documentIngestionLoadingDocuments: "Cargando documentos ingeridos…",
  documentIngestionLoadError: "No se pudieron cargar los documentos del vector store.",

  globalIngestionButton: "Ingesta global",
  globalIngestionDialogTitle: "Ingesta global de conocimiento",
  globalIngestionDialogDescription:
    "Información general no ligada a un proyecto (leyes, normativa, conceptos). Se almacena con projectId GLOBAL. Mismas reglas de descripción: PDF/Word por archivo pueden ir sin texto; imágenes/video/plano/brochure requieren descripción larga.",
  globalIngestionDocumentsSection: "Documentos",
  globalIngestionDocTypeLabel: "Tipo de documento",
  globalIngestionLoadingDocuments: "Cargando documentos globales (GLOBAL)…",
  globalIngestionLoadError: "No se pudieron cargar los documentos globales.",
  globalIngestionSendCount: "Enviar {{count}} documento(s) global(es)",
  globalIngestionNothingToSend: "No hay documentos globales listos para enviar.",
  globalIngestionSuccess: "{{count}} documento(s) global(es) ingerido(s).",

  ingestionDocTypeImages: "Imágenes",
  ingestionDocTypePlane: "Plano",
  ingestionDocTypeBrochure: "Brochure",
  ingestionDocTypeReellVideo: "Reel / Video",
  ingestionDocTypeRut: "RUT",
  ingestionDocTypeBusinessRegistration: "Registro mercantil",
  ingestionDocTypeBankCertificate: "Certificado bancario",
  ingestionDocTypeLibertarianCertificate: "Certificado de libertad",
  ingestionDocTypeOther: "Otro",

  formSectionLegalDocuments: "Documentos legales (ingesta RAG)",
  legalDocumentsSectionHint:
    "Archivos guardados al ingerir tipos RUT, registro mercantil, certificado bancario o certificado de libertad. Enlaces de solo lectura.",
  legalDocOpenFile: "Abrir archivo",
  legalDocRut: "RUT",
  legalDocBusinessRegistration: "Registro mercantil",
  legalDocBankCertificate: "Certificado bancario",
  legalDocLibertarianCertificate: "Certificado de libertad",

  listColPublicStock: "Inventario público",
  listOpenPublicStock: "Abrir inventario público",
  listCopyPublicStock: "Copiar enlace público",
  listCopiedPublicStock: "Copiado",
  listPublicStockViewLabel: "Vista del enlace",
  listPublicStockViewDefault: "Predeterminada",
  listPublicStockViewMap: "Mapa (#map)",
  listPublicStockViewGrid: "Cuadrícula (#grid)",
  listPublicStockViewColumns: "Columnas (#columns)",
  listMissingAgentBaseUrl: "Configura VITE_AGENT_BASE_URL",
  listColAudience: "Audiencia",
  listAudienceLaCeiba: "La Ceiba",
  listAudienceExternal: "Externa",
  listAudienceHint:
    "Puedes activar La Ceiba (sitio propio, ventores y asistente), Distribución externa (empresas aliadas), o ambas. Al menos una debe quedar activa.",
  listLaCeibaChip: "La Ceiba",
  listExternalChip: "Externo",
  listBothChip: "La Ceiba + Externo",

  formFieldShortDescription: "WhatsApp description",
  formFieldShortDescriptionHelper: "Plain-text teaser shown on cards and listings.",
  formSectionImages: "Images",
  formSectionVideos: "Videos",
  formSectionDocuments: "Floor plan and brochure",
  formSectionLegal: "Legal documents",
  formExpandAll: "Expand all",
  formCollapseAll: "Collapse all",
  formSectionNeedsAttention: "Needs attention",
  formSummaryEmpty: "Not set",
  formSummaryLotOptions: "Lot options: {count}",
  formSummaryGroups: "Groups: {count}",
  formSummaryImages: "Images: {count}",
  formSummaryVideos: "Videos: {count}",
  formSummaryFiles: "Files: {count}/2",
} as const
